module.exports = "https://web-assets.ifttt.com/packs/media/docs/social_media_example-7020c19b.png";